import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";


function NameMatch() {
  const [values, setValues] = useState({ name: "", panname: "" });
  const [BeneficiaryNameWithBank, setBeneficiaryNameWithBank] = useState("");
  const [PanName, setPanName] = useState("");
  const [IsMatch, setIsMatch] = useState("");
  const [requestid, setRequestid] = useState("");
  const [ConfidenceScore, setConfidenceScore] = useState("");
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);

    const formFieldsObject = {
      ...values,
      [name]: value,
    };

    setValues(formFieldsObject);
  };

  const onSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    // await fetch(
    //   `https://atq82myy30.execute-api.ap-south-1.amazonaws.com/default/namematchservice?BeneficiaryNameWithBank=${values.name}&PanName=${values.panname}`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "x-api-key": "RHdm0ecopO4nGCjIdaHrY2mcLRo2VvkN49gtnVQH",
    //       authorizationToken: "MkTtvS5KKRCKpBQR",
    //     },
    //   }
    // )
    await fetch(
      `https://devcswuuvf.execute-api.ap-south-1.amazonaws.com/default/replicanamematch?BeneficiaryNameWithBank=${values.name}&PanName=${values.panname}`,
      {
        method: "POST",
        // headers: {
        //   "x-api-key": "UaOa8Gb00g5VRbtrA4FoAaG9WZUT0937WUVgS9b0",
        //   authorizationToken: "dmPETdVDB4F8fNFL",
        // },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setBeneficiaryNameWithBank(data.BeneficiaryNameWithBank);
        setPanName(data.PanName);
        setIsMatch(data.IsMatch);
        setRequestid(data.requestid);
        setConfidenceScore(data.ConfidenceScore)
        console.log(data.setBeneficiaryNameWithBank);
        sessionStorage.setItem("Name", "");
        setLoading(false)
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false)
      });

    // if (response.status !== 200) {
    //   throw new Error(`Request failed: ${response.status}`);
    // }

  };


  return (
    <div>
      <div>
        <div class="container containerBoreder " id="pan">
          <h2 class="pageTitle">Name Match</h2>
          <div class="row">
            <div class="col-4">
              <input
                name="name"
                placeholder="Name as per Bank"
                value={values.name}
                onChange={handleChange}
              />
              <input
                name="panname"
                placeholder="Name as per Pan"
                value={values.panname}
                onChange={handleChange}
              />
            </div>
            <div class="col-4">
              {loading ? (
                <ReactBootStrap.Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </ReactBootStrap.Spinner>
              ) : <>
                <button class="btn btn-primary" type="submit" onClick={onSubmit}>
                  Submit
                </button>
              </>}
            </div>
          </div>
          <br />

          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Name as per Bank</th>
                <td>{BeneficiaryNameWithBank} </td>
              </tr>
              <tr>
                <th> Pan Name</th>
                <td>{PanName}</td>
              </tr>
              <tr>
                <th> Is Matched</th>
                <td>{IsMatch}</td>
              </tr>
              <tr>
                <th> Request Id</th>
                <td>{requestid}</td>
              </tr>
              <tr>
                <th> Confidence Score</th>
                <td>{ConfidenceScore}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
}

export default NameMatch;
